import { CheckBox, Label } from '@iwoca/orion';
import { Column } from '@tanstack/react-table';
import { FilterActionButtons } from 'components/FilterActionButtons/FilterActionButtons';
import { TIntroducerListItem } from '../UsersTable.types';
import styles from './SelectColumnFilter.module.css';
import { useSelectColumnFilter } from './useSelectColumnFilter.hook';

type TProps = {
  column: Column<TIntroducerListItem, unknown>;
  onClose: () => void;
};

export const SelectColumnFilter = ({ column, onClose }: TProps) => {
  const { options, selectedValues, handleChange, handleReset, handleApply } =
    useSelectColumnFilter({ column, onClose });

  return (
    <>
      <div className={styles.items}>
        {options.map(({ value, label }) => (
          <div className={styles.filterItem} key={value}>
            <CheckBox
              id={column.id + value}
              name={value}
              checked={selectedValues.includes(value)}
              onChange={handleChange}
              data-testid={`${value}-checkbox`}
            />
            <Label htmlFor={column.id + value} className={styles.filterLabel}>
              {label}
            </Label>
          </div>
        ))}
      </div>
      <FilterActionButtons
        onResetClick={handleReset}
        onApplyClick={handleApply}
      />
    </>
  );
};
